var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L18 5L12 2V12",
    stroke: "#3B3B58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99914 11.99L2.49914 15.13C2.34524 15.2172 2.21723 15.3437 2.12817 15.4965C2.03911 15.6494 1.99219 15.8231 1.99219 16C1.99219 16.1769 2.03911 16.3506 2.12817 16.5035C2.21723 16.6563 2.34524 16.7828 2.49914 16.87L10.9991 21.73C11.3032 21.9055 11.6481 21.9979 11.9991 21.9979C12.3502 21.9979 12.6951 21.9055 12.9991 21.73L21.4991 16.87C21.653 16.7828 21.781 16.6563 21.8701 16.5035C21.9592 16.3506 22.0061 16.1769 22.0061 16C22.0061 15.8231 21.9592 15.6494 21.8701 15.4965C21.781 15.3437 21.653 15.2172 21.4991 15.13L15.9991 12M6.48914 12.85L17.5091 19.15M17.5091 12.85L6.49914 19.15",
    stroke: "#3B3B58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.c04132cfd0c170da3e55ef7ba83a5caa.svg";
export { ForwardRef as ReactComponent };